import React from 'react';

import svg from './assets/icons-16-photo.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconPhoto = (props: IconProps) => <SvgIcon {...props} src={svg} testId="icon-photo" />;
